import TouchModule from '../../features/touch';

export default {
  __depends__: [
    TouchModule
  ]
};